import React from "react";
import { withRouter } from "../_shared/withRouter";
import ResetTokenComponent from "../template/auth/resetToken";

const ForgotPassword = () => {
  return <ResetTokenComponent roleType={"admin"} role={"2"} />;
};

export default withRouter(ForgotPassword);
